import { render, staticRenderFns } from "./assetApply.vue?vue&type=template&id=25a36e72&scoped=true&"
import script from "./assetApply.vue?vue&type=script&lang=js&"
export * from "./assetApply.vue?vue&type=script&lang=js&"
import style0 from "./assetApply.vue?vue&type=style&index=0&id=25a36e72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a36e72",
  null
  
)

export default component.exports